<template>
  <div id="index">
    <v-card flat>
      <p style="margin-bottom:0;">
        <img
          class="white--text"
          :src="require('@/assets/img/top.png')"
          :class="{imageSP: isSP, imageMD: !isSP}"
          alt='辛くていいね！'
      />
      </p>
      <v-container>
        <router-link :to="{name: 'about'}" style="font-weight:bold;color:#000;font-size:11pt;text-decoration:none;">激辛グルメSNS「<span style="color:#f44336;text-decoration:underline;font-weight:bold">カライイネ</span>」とは？</router-link>
      </v-container>
    </v-card>
    <!-- 最近追加-->
    <v-card flat style="margin-top:16px;">
      <v-flex xs12 style="padding: 16px 16px 0px 16px">
        <h2 style="margin-bottom:10px;text-align:left;font-size:20pt;">最近追加された<span class="primary--text">辛い</span>食品</h2>
      </v-flex>
      <div xs12 style="padding-bottom:16px;min-height:100px;overflow-x: auto;">
        <v-layout row>
          <v-flex v-for="(f, id) in recentAddFoods" :key=id >
            <food-card-image-user :f=f></food-card-image-user>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
    <!-- ／最近追加-->
    <!-- 検索-->
    <v-card flat style="margin:16px 0;">
      <v-container>
        <h2 style="margin-bottom:2px;text-align:left;font-size:20pt;"><span class="primary--text">激辛、旨辛</span>を検索</h2>
        <v-flex xs12>
          <v-layout v-if="searchMode==='food'" row wrap style="margin-bottom:10px;">
            <v-flex xs6><v-btn @click="searchMode='food'" block class="primary" dark>食品</v-btn></v-flex>
            <v-flex xs6><v-btn @click="searchMode='restaurant'" block class="primary primary--text" outline><v-icon small>restaurant</v-icon>飲食店</v-btn></v-flex>
          </v-layout>
          <v-layout v-else row wrap style="margin-bottom:10px;">
            <v-flex xs6><v-btn @click="searchMode='food'" block class="primary primary--text" outline>食品</v-btn></v-flex>
            <v-flex xs6><v-btn @click="searchMode='restaurant'" block class="primary" dark><v-icon small>restaurant</v-icon>飲食店</v-btn></v-flex>
          </v-layout>
        </v-flex>
        <!-- 食品検索 -->
        <v-layout v-show="searchMode==='food'" row wrap style="background:#fff;border-radius:2px;border: solid 1px #aaa;">
          <v-flex xs4>
            <select v-model="query.category" 
              style="color:#f44336;width:100%;height:50px;border-right:1px solid #aaa;padding:0 10px">
              <option selected value="none">カテゴリ▼</option>
              <option v-for="(item, id) in configCategory" :key=id :value="item.key">{{item.value}}</option>
            </select>
          </v-flex>
          <v-flex xs5>
            <input  v-model="query.kwd"
            type="text" placeholder="検索キーワード" style="height:50px;width:100%;padding:0 10px;color:#f44336;">
          </v-flex>
            <v-flex xs3>
              <v-btn @click="onSearch"
                block color="primary" dark style="height:100%;position:relative;top:-6px;left:2px;"><v-icon>search</v-icon>検索</v-btn>
            </v-flex>
        </v-layout>
        <!-- ／食品検索 -->
        <!-- 飲食店検索 -->
        <v-layout v-show="searchMode==='restaurant'" row wrap style="background:#fff;border-radius:2px;border: solid 1px #aaa;">
          <v-flex xs4>
            <select v-model="query.pref" 
              style="color:#f44336;width:100%;height:50px;border-right:1px solid #aaa;padding:0 10px">
              <option selected value="none">都道府県▼</option>
              <option v-for="(item, id) in prefs" :key=id :value="item">{{item}}</option>
            </select>
          </v-flex>
          <v-flex xs5>
            <input  v-model="query.kwd"
            type="text" placeholder="店名・地名など" style="height:50px;width:100%;padding:0 10px;color:#f44336;">
          </v-flex>
            <v-flex xs3>
              <v-btn @click="onSearch"
                block color="primary" dark style="height:100%;position:relative;top:-6px;left:2px;"><v-icon>search</v-icon>検索</v-btn>
            </v-flex>
        </v-layout>
        <!-- ／飲食店検索 -->
        <p style="margin-top:8px;margin-bottom:0;">
          <span v-if="searchMode==='food'">激辛カップ麺などの食品を検索</span>
          <span v-if="searchMode==='restaurant'">激辛な飲食店・レストランを検索</span>
        </p>
      </v-container>
    </v-card>
    <!-- ／検索-->

    <!-- 辛さランキング -->
    <v-card flat style="margin-top:16px;">
      <v-container>
      <v-flex xs12>
        <h2 style="margin-bottom:10px;text-align:left;font-size:20pt;"><span class="primary--text">辛さ</span>ランキング</h2>
      </v-flex>
      <p style="font-weight:bold;text-align:left">みんなの辛さ比較からランキングを作りました！</p>
      <v-btn class="rankBtn" color="primary" large block :to="{name: 'searchFood', query: {sort: 'hot'}}">
        <img src="/img/rankIcon/chilifire.png" alt="辛さランキング">全体の辛さランキング
      </v-btn>
      <v-layout row wrap>
        <v-flex xs6 style="padding-right:5px">
          <v-btn class="rankBtn" outline color="primary" block :to="{name: 'searchFood', query: {category: 'nudle',sort: 'hot'}}">
            <img src="/img/rankIcon/nudle.png"  alt="ラーメンの辛さランキング">ラーメン
          </v-btn>
        </v-flex>
        <v-flex xs6 style="padding-left:5px">
          <v-btn class="rankBtn" outline color="primary" block :to="{name: 'searchFood', query: {category: 'curry',sort: 'hot'}}">
            <img src="/img/rankIcon/curry.png"><span style="margin-right:16px;" alt="カレーの辛さランキング">カレー</span>
          </v-btn>
        </v-flex>
        <v-flex xs6 style="padding-right:5px">
          <v-btn class="rankBtn" outline color="primary" block :to="{name: 'searchFood', query: {category: 'yakisoba',sort: 'hot'}}">
            <img src="/img/rankIcon/yakisoba.png" alt="やきそばの辛さランキング">やきそば
          </v-btn>
        </v-flex>
        <v-flex xs6 style="padding-left:5px">
          <v-btn class="rankBtn" outline color="primary" block :to="{name: 'searchFood', query: {category: 'rice',sort: 'hot'}}">
            <img src="/img/rankIcon/gohan.png" alt="ごはん系の辛さランキング">ごはん系
          </v-btn>
        </v-flex>
        <v-flex xs6 style="padding-right:5px">
          <v-btn class="rankBtn" outline color="primary" block :to="{name: 'searchFood', query: {category: 'snack',sort: 'hot'}}">
            <img src="/img/rankIcon/okashi.png" alt="お菓子の辛さランキング"><span style="margin-right:16px;">お菓子</span>
          </v-btn>
        </v-flex>
        <v-flex xs6 style="padding-left:5px">
          <v-btn class="rankBtn" outline color="primary" block :to="{name: 'searchFood', query: {category: 'tsumami',sort: 'hot'}}">
            <img src="/img/rankIcon/otsumami.png" alt="おつまみの辛さランキング">おつまみ
          </v-btn>
        </v-flex>
      </v-layout>
      </v-container>
    </v-card>
    <!-- ／辛さランキング -->

    <!-- rank-->
    <v-card flat style="margin-top:16px;">
      <v-flex xs12 style="padding: 16px 16px 0px 16px">
        <h2 style="margin-bottom:10px;text-align:left;font-size:20pt;">みんなの<span class="primary--text">辛さ比較</span></h2>
      </v-flex>
      <div xs12 style="min-height:100px;overflow-x: auto;overflow-y:hidden;">
        <v-layout row>
          <v-flex v-for="(r, id) in rank" :key="id" style="padding:5px;">
            <rank-card :r="r" @onRankClick=onRankClick></rank-card>
          </v-flex>
        </v-layout>
      </div>
      <p style="padding-bottom:16px;font-weight:bold;">みんなの辛さランキングを見てみよう！</p>
    </v-card>
    <!-- rank-->

    <v-card flat style="text-align:left;background:#fff;padding:16px;">
      <v-layout row wrap style="min-height:500px;">
        <v-flex md4 v-if="!isSP" style="padding-right:16px;">
          <karalog-info></karalog-info>
        </v-flex>
        <v-flex xs12 md8 :class="{round: !isSP}">
          <h2 style="margin-bottom:16px;font-size:20pt;">新着カラログ</h2>
          <div style="min-height: 500px;">
            <template v-if="newPosts.length>0">
              <review-card 
                v-for="(p, id) in newPosts"
                :post=p :key=id
                :showFood=true
                @onReviewCardClick=onReviewCardClick
                @onMessage=onMessage
                style="margin-bottom:16px;"
              ></review-card>
              <v-btn :to="{name: 'searchReview'}"  
                block dark color="primary" large>もっとカラログを見る</v-btn>
            </template>
            <div v-else style="text-align:center;margin-top:30px;width:100%;">
              <v-progress-circular :size="50" :width="5" color="primary" indeterminate></v-progress-circular>
            </div>
          </div>
          <v-flex xs12 v-if="isSP" style="margin-top:32px;border-top:1px solid #ccc;">
            <karalog-info></karalog-info>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
    <!-- 人気商品 -->
    <v-card flat style="margin-top:16px;">
      <v-flex xs12 style="padding: 16px 16px 0px 16px">
        <h2 style="margin-bottom:10px;text-align:left;font-size:20pt;">人気な激辛・旨辛食品</h2>
      </v-flex>
      <v-flex xs12>
        <food-card 
          @onFoodCardClick="$router.push({name: 'searchFoodDetail', params: {id: food.id}})"
          :food="food" v-for="(food, id) in foods" :key=id
          style="padding:5px;border-bottom:solid 1px #ddd;"
        ></food-card>
      </v-flex>
      <v-flex xs12 style="padding: 10px 16px 0px 16px">
        <v-btn color="primary" large flat :to="{name: 'searchFood'}" style="font-size:13pt;font-weight:bold;text-decoration:underline">もっと辛い食品を見る</v-btn>
      </v-flex>
    </v-card>
    <!-- ／人気商品 -->
    <!-- 新商品 -->
    <!-- <v-card flat style="margin-top:16px;">
      <v-flex xs12 style="padding: 16px 16px 0px 16px">
        <h2 style="margin-bottom:10px;text-align:left;font-size:20pt;">新発売な辛い食品</h2>
      </v-flex>
      <v-flex xs12 style="padding-bottom:16px;min-height:100px;">
        <v-layout row wrap>
          <v-flex xs4 md2 v-for="(f, id) in newFoods" :key=id>
            <v-card style="padding:2px 10px;" flat :to="{name: 'searchFoodDetail', params: {id: f.id}}">
              <v-img :src="f.imageurl" aspect-ratio=1 :alt="f.name">
                <v-layout fill-height>
                  <v-flex xs12>
                    <v-chip color=primary label small dark>{{f.releaseDate | formatDate}}</v-chip>
                  </v-flex>
                </v-layout>
              </v-img>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card> -->
    <!--／ 新商品 -->
    <v-card flat style="margin-top: 16px; padding-bottom: 16px;">
      <v-flex xs12 style="padding: 16px 16px 0px 16px">
        <h2 style="margin-bottom:10px;text-align:left;font-size:16pt;">SNSでカライイネをシェアしよう</h2>
        <sns-buttons></sns-buttons>
      </v-flex>
    </v-card>
</div>
</template>

<script>
// @ is an alias to /src
import ReviewCard from '@/components/card/ReviewCard.vue'
import FoodCard from '@/components/card/FoodCard.vue'
import FoodCardImageUser from '@/components/card/FoodCardImageUser.vue'
import RankCard from '@/components/card/RankCard.vue'
import KaralogInfo from '@/components/card/KaralogInfo.vue'
import SnsButtons from '@/components/common/SnsButtons.vue'
import { db } from '@/main'
import getImageUrl from '@/assets/js/getImageUrl.js'

export default {
  name: 'home',
  data () {
    return {
      prefs: ['北海道' ,'青森県' ,'岩手県' ,'宮城県' ,'秋田県' ,'山形県' ,'福島県' ,'茨城県' ,'栃木県' ,'群馬県' ,'埼玉県' ,'千葉県' ,'東京都' ,'神奈川県' ,'新潟県' ,'富山県' ,'石川県' ,'福井県' ,'山梨県' ,'長野県' ,'岐阜県' ,'静岡県' ,'愛知県' ,'三重県' ,'滋賀県' ,'京都府' ,'大阪府' ,'兵庫県' ,'奈良県' ,'和歌山県' ,'鳥取県' ,'島根県' ,'岡山県' ,'広島県' ,'山口県' ,'徳島県' ,'香川県' ,'愛媛県' ,'高知県' ,'福岡県' ,'佐賀県' ,'長崎県' ,'熊本県' ,'大分県' ,'宮崎県' ,'鹿児島県' ,'沖縄県'],
      phraseWordIndex: 0,
      query: {
        kwd: '',
        category: 'none',
        pref: 'none'
      },
      newPosts: [],
      foods: [],
      newFoods: [], // 新発売
      recentAddFoods: [], //最近追加された食品
      searchMode: 'food',
      postLength: 4,
      rank: [],
      news: []
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.user.isLogin
    },
    configCategory () {
      return this.$store.state.config.category
    },
    displaySize () {
      return this.$vuetify.breakpoint.name
    },
    isSP () {
      if (this.displaySize==='xs' || this.displaySize==='sm') return true
      return false
    },
    newFoodsLimit () {
      return 6
    }
  },
  filters: {
    formatDate (v) {
      let chars = v.split('-')
      return `${chars[1]}月${chars[2]}日`
    },
    textTrim: function (value, max) {
      if (value.length >= max) return value.substring(0, max - 1) + '...'
      return value
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.getRecentAddFoods()
      this.getNewPosts()
      this.getRank()
      this.getFoods()
      // this.getNewFoods()
    },
    onSearch () {
      let query = {}
      if (this.query.kwd !== '') {
        query.kwd = this.query.kwd
      }
      if (this.searchMode === 'food') {
        if (this.query.category !== 'none') {
          query.category = this.query.category
        }
        this.$router.push({name: 'searchFood', query: query})
      } else if (this.searchMode === 'restaurant') {
        if (this.query.pref !== 'none') {
          query.pref = this.query.pref
        }
        this.$router.push({name: 'searchShops', query: query})
      }
    },
    async getFoods () {
      let list = await this.$store.dispatch('getFoodByQuery', true)
      if (list.length > 6) {
        for (let i = 0; i < 6; i++) {
          this.foods.push(list[i])
        }
      } else {
        this.foods = list
      }
    },
    async getNewPosts () {
      let list = await this.$store.dispatch('getPostByQuery')
      if (list.length > this.postLength) {
        for (let i = 0; i < this.postLength; i++) {
          this.newPosts.push(list[i])
        }
      } else {
        this.newPosts = list
      }
    },
    async getRank () {
      let list = await this.$store.dispatch('getRank')
      for (let i = 0; i < 20; i++) {
        this.rank.push(list[i])
      }
    },
    onReviewCardClick (post, position) {
      this.$router.push({name: 'searchReviewDetail', params: {id: post.id}, query: {position: position}})
    },
    onMessage (obj) {
      this.$emit('onMessage', obj)
    },
    async getNewFoods () {
      let response = await db.collection('food').orderBy('releaseDate', 'desc').limit(this.newFoodsLimit).get()
      response.forEach(doc => {
        let f = doc.data()
        f.id = doc.id
        let url = getImageUrl.get('food_thumbs', f.id, f.images[0])
        f.imageurl = url
        this.newFoods.push(f)
      })
    },
    async getRecentAddFoods () {
      let response = await db.collection('food').orderBy('timestamp', 'desc').limit(10).get()
      response.forEach(doc => {
        let f = doc.data()
        f.id = doc.id
        let url = getImageUrl.get('food_thumbs', f.id, f.images[0])
        f.imageurl = url
        this.recentAddFoods.push(f)
      })
    },
    onRankClick(id) {
      this.$router.push({name: 'UserTop', params: {id: id}, query: {p: 'rank'}})
    }
  },
  components: {
    ReviewCard,
    KaralogInfo,
    SnsButtons,
    FoodCard,
    RankCard,
    FoodCardImageUser
  },
  head: {
    title () {
      return {
        inner: 'カライイネ',
        separator: ' - ',
        complement: '激辛グルメ好きのためのグルメSNS。辛さの相対評価「辛さ比較」をやってみよう！'
      }
    },
    meta () {
      return [
        {name: 'description', content: 'カライイネは激辛・旨辛など辛い食品・飲食店に特化した口コミグルメSNSです。激辛ラーメン、旨辛カレーなどなど辛い食品情報をシェアしよう！激辛ランキングを見てみよう！'},
        {name: 'keywords', content: '激辛,旨辛,激辛カップ麺,激辛やきそば,激辛ランキング,激辛ラーメン'}
      ]
    }
  }
}
</script>

<style scoped>
  #index{
    min-height:90vh;
    text-align:center;
  }
  input::placeholder {
  color: #f44336;
  }
  .round {
    border-radius:10px
  }
  .imageSP {
    width: 80%;
  }
  .imageMD {
    height: 300px;
  }
  .rankBtn {
    font-weight:bold;
    font-size:13pt;
    border-radius:6px;
    height:55px;
  }
  .rankBtn img {
    height:40px;
    margin-right:10px;
  }
</style>
>